// extracted by mini-css-extract-plugin
export var background = "_6x-0";
export var container = "_6x-1";
export var contentItem = "_6x-7";
export var extendedWarranty = "_6x-5";
export var link = "_6x-d";
export var modal = "_6x-b";
export var modalCloseButton = "_6x-9";
export var modalContent = "_6x-3";
export var modalContentMain = "_6x-6";
export var modalImageLogo = "_6x-8";
export var modalLogo = "_6x-a";
export var modalSideImage = "_6x-4";
export var preview = "_6x-c";
export var redoModal = "_6x-2";